import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import styles from "./assets/styles/formatTicket.styles";
import clsx from "clsx";

const useStyles = makeStyles(styles);

export default function FormatTicket({
  primaryDimension,
  active,
  secondaryDimension,
  num,
  handleChange,
}) {
  const classes = useStyles();
  return (
    <div
      style={{ cursor: "none" }}
      className={classes.root}
      onClick={() => handleChange(num)}
    >
      <Checkbox
        style={{ cursor: "none" }}
        icon={<span className={classes.unChecked}></span>}
        checkedIcon={
          <span className={classes.checked}>
            <span className={classes.inner}></span>
          </span>
        }
        checked={active}
        onChange={() => handleChange(num)}
      />
      <span className={classes.content}>
        {primaryDimension === "15x90 cm" ? (
          <span
            className={clsx(classes.smallDimension, active && classes.active)}
          ></span>
        ) : (
          <span
            className={clsx(classes.bigDimension, active && classes.active)}
          ></span>
        )}
        <p className={clsx(classes.p, active && classes.active)}>
          {primaryDimension}
        </p>
        <p className={clsx(classes.secondaryP, active && classes.active)}>
          {secondaryDimension}
        </p>
      </span>
    </div>
  );
}
